import {
  ActionType,
  PDFDownloadScoringInfoResponse,
  IMentalCheckScoringDownloadPayload,
} from "models/mentalHealth/pdfDownloadScoringInfo";

export const pdfDownloadScoringInfoAction = (
  payload: IMentalCheckScoringDownloadPayload
) => {
  return {
    type: ActionType.PDF_DOWNLOAD_SCORING_INFO,
    payload,
  };
};

export const handleErrorAction = (payload: string) => {
  return {
    type: ActionType.PDF_DOWNLOAD_SCORING_INFO_ERROR,
    payload,
  };
};

export const handleSuccesAction = (payload: PDFDownloadScoringInfoResponse) => {
  return {
    type: ActionType.PDF_DOWNLOAD_SCORING_INFO_SUCCESS,
    payload,
  };
};

export const handleResetDataAction = () => {
  return {
    type: ActionType.PDF_DOWNLOAD_SCORING_INFO_RESET_DATA,
  };
};
